import { getIdOrNull, getTrimmedOrNull, validateString } from '../index'
import { Properties } from '../entities'

export const Formats = Object.freeze({
  DEFAULT: 'default',
  PUBLIC_CREATE: 'publicCreate'
})

export const SchoolProperties = Object.freeze({
  ID: Properties.ID,
  ABBREVIATION: Properties.ABBREVIATION,
  ADDRESS: Properties.ADDRESS,
  COUNTRY: Properties.COUNTRY,
  EMAIL: Properties.EMAIL,
  NAME: Properties.NAME,
  PHONE_NUMBER: Properties.PHONE_NUMBER,
  PREMIUM: Properties.PREMIUM,
  VERIFIED: Properties.VERIFIED,
  MANAGED: Properties.MANAGED
})

export const SCHOOL_VALIDATORS = [
  { key: Properties.NAME, validator: s => validateString(s[Properties.NAME], { notEmpty: true }) },
  { key: Properties.ABBREVIATION, validator: s => validateString(s[Properties.ABBREVIATION], { notEmpty: true }) }
]

export const SchoolValidators = Object.freeze({
  [Properties.NAME]: s => validateString(s[Properties.NAME], { notEmpty: true }),
  [Properties.ABBREVIATION]: s => validateString(s[Properties.ABBREVIATION], { notEmpty: true }),
  [Properties.ADDRESS]: s => validateString(s[Properties.ADDRESS], { notEmpty: true }),
  [Properties.COUNTRY]: s => getIdOrNull(s[Properties.COUNTRY]) !== null || validateString(s[Properties.COUNTRY], { notEmpty: true }),
  [Properties.EMAIL]: s => validateString(s[Properties.EMAIL], { isEmail: true, notEmpty: true }),
})

export const getName = s => {
  return s.name
}

export const getAddress = s => {
  return s.address
}

export const getEmail = s => {
  return s.email
}

export const getPhoneNumber = s => {
  return s.phoneNumber
}

export class School {
  constructor ({ id, abbreviation, address, country, email, managed, name, phoneNumber, premium, verified } = {}) {
    this.id = id ?? -1
    this.abbreviation = abbreviation ?? ''
    this.address = address ?? ''
    this.country = country ?? null
    this.email = email ?? null
    this.managed = managed ?? false
    this.name = name ?? ''
    this.phoneNumber = phoneNumber ?? ''
    this.premium = premium ?? false
    this.verified = verified ?? false
  }

  toRequestBody = (format = Formats.DEFAULT) => {
    const body = this.trimmed()

    body.country = getIdOrNull(this.country)

    if (format === Formats.PUBLIC_CREATE) {
      body.phone = body.phoneNumber

      delete body.phoneNumber
    }

    return body
  }

  trimmed = () => {
    const trimmed = { ...this }

    trimmed.name = getTrimmedOrNull(trimmed.name)
    trimmed.abbreviation = getTrimmedOrNull(trimmed.abbreviation)
    trimmed.address = getTrimmedOrNull(trimmed.address)
    trimmed.email = getTrimmedOrNull(trimmed.email)
    trimmed.phoneNumber = getTrimmedOrNull(trimmed.phoneNumber)

    return trimmed
  }
}
